import React from "react";
import Marquee from "./Marquee";
import { CREDENTIALS, PRINCIPLES } from "../mock";

export default function Logos() {
  const principles = PRINCIPLES.map((p, i) => (
    <span key={i} className="font-display text-3xl md:text-4xl text-ink/70">
      {p.t} <span className="text-amber">·</span>
    </span>
  ));
  const creds = CREDENTIALS.map((c, i) => (
    <span key={i} className="text-eyebrow text-ink/55">{c}</span>
  ));
  return (
    <>
      <section className="bg-bone border-b border-line py-10">
        <div className="max-w-[1440px] mx-auto px-6 lg:px-10">
          <div className="text-eyebrow text-ink/45 mb-6 rv">— What we stand for</div>
        </div>
        <Marquee items={principles} speed="marquee-fast" />
      </section>
      <section className="bg-bone py-6 border-b border-line">
        <Marquee items={creds} speed="marquee" />
      </section>
    </>
  );
}
